var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[(_vm.hasSelectedBrand || _vm.id)?_c('Brand'):_c('Brands')],1)}
var staticRenderFns = []

export { render, staticRenderFns }